import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Role.css";
import { ViewContainer } from "./../../View.jsx";
import { RolePermissionForm } from './RolePermissionForm';
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";

const roleRef = React.createRef();
const utils = new ViewUtils();
const toolbarRef = React.createRef();

class RolePermission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: {
               NavigationID: null
            },
            title: "",
            id: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) ? this.props.location.state.selection : null,
            RoleName: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.RoleName)) ? this.props.location.state.RoleName : null,
            RoleSAQACode: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.RoleSAQACode)) ? this.props.location.state.RoleSAQACode : null,
            RoleID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.RoleID)) ? this.props.location.state.RoleID : null,
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon' }
                    ]
                }
            ]
        };
    }



    handleFormValueChange(values) {
        if (JSON.stringify(this.state.modal) !== JSON.stringify(values)) {
            if (!utils.isNull(values.NavigationID)) {
                values.MenuItemName = values.NavigationID.Description;
            }
            this.setState({ modal: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else {
            this.close();
        }
    }

    save() {
        let formValue = roleRef.current.getValue();

        if (formValue !== null && typeof formValue !== 'undefined') {
            formValue.RoleID = this.state.RoleID;
            let isAdd = true;
            //if (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) {
            //    formValue.id = this.props.location.state.selection;
            //    isAdd = false;
            //}
            if (!utils.isNull(this.state.id)) {
                formValue.id = this.state.id;
                isAdd = false;
            }
            //let data = JSON.stringify(formValue);

            if (isAdd) {
                const url = `api/sims/permissiondetails/insertpermission`;
                utils.saveForm(this, roleRef, url, (response) => {
                    if (response.MessageType === 'SUCCESS') {
                        this.setState({ id: response.EntityId, message: response.Message, messageStyle: response.MessageType });
                    }
                    else {
                        this.setState({ message: response.Message, messageStyle: response.MessageType });
                    }
                }, this.error);
            } else {
                const url = `api/sims/permissiondetails/updatepermission`;
                utils.updateForm(this, roleRef, url, (response) => {
                    this.setState({ message: response.Message, messageStyle: response.MessageType });
                }, this.error);
            }
        }
    }

    error(response) {
        this.setState({ message: "A system error has accured. Please contact your system administrator", messageStyle: "ERROR" });

    }

    close() {
        this.props.history.push({
            pathname: '/rolePermissionSearch',
            state: {
                selection: this.state.RoleID,
                RoleName: this.state.RoleName,
                RoleSAQACode: this.state.RoleSAQACode
            }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title=''>
                <p className="breadcrumbs">
                    {"Role Maintenance > Roles & Permissions > " + this.state.RoleName + " - " + this.state.RoleSAQACode + " > Permissions" + (this.state.id !== null ? "" : " > Add")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    ref={toolbarRef}
                                    title="Role"
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <RolePermissionForm
                                    dataUrl='api/sims/permissiondetails/getfind'
                                    ref={roleRef}
                                    id={this.state.id}
                                    valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                    RoleID={this.state.RoleID}
                                    data={this.state.modal}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(RolePermission);